import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Icon } from "components/common";
const WarningIcon = styled(Icon)`
  margin-right: 5px;
`;
const WidgetTitle = ({
  title,
  isLoading,
  detailsAreAvailable
}) => {
  const { t } = useTranslation("enterprise_report");
  if (isLoading) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, t("widget_title.loading"));
  }
  if (!detailsAreAvailable) {
    return /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(WarningIcon, { name: "warning" }), /* @__PURE__ */ React.createElement("i", null, t("widget_title.not_accessible")));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, title);
};
export default WidgetTitle;
